/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDiyPage {
  pageHeading?: string;
  pageImage?: string;
  pageText?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class DiyActivity extends Component {
  private readonly diyPage: IDiyPage = {
    pageHeading: 'toy shadow tracing',
    pageImage:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDvdE',
    pageText:
      'Tracing and coloring skills get a workout with this indoor or outdoor DIY. Dinosaur figures make colossally cool shadows, but you can use favorite characters, dolls, you name it! If you’re playin’ outdoors, let ol’ Mr. Sun shine down to create shadows. For indoor play, just shine a flashlight and trace away!',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.diyPage.pageHeading}</h1>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-image'>
              <img
                className='img-responsive'
                src={this.diyPage.pageImage}
                alt={this.diyPage.pageHeading}
              />
            </div>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-text'>
              <p>{this.diyPage.pageText}</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DiyActivity;
